import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { isNil, isEmpty } from 'ramda';

import { renderField } from '../utilities/form';
import { required } from '../utilities/validation';

const LoginForm = (props) =>  {
  const { handleSubmit, invalid } = props;

  return (
    <div className="flex flex-wrap justify-center">
      <div className="w-full max-w-sm">
        <form className="px-8 pt-6 pb-8 mb-4" onSubmit={handleSubmit}>
          <h1 className="text-2xl font-serif font-black mb-8">Benvenuto in Smart Gaming</h1>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="username">
              Indirizzo email
            </label>
            <Field
              id="username"
              className="appearance-none border border-gray-400 rounded-full w-full py-2 px-5 text-gray-700 leading-tight focus:outline-none focus:shadow"
              name="username"
              type="text"
              component={renderField}
              validate={[required]}
              placeholder="john.appleseed@email.com" />
          </div>
          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="password">
              Password
            </label>
            <Field
              id="password"
              className="appearance-none border border-gray-400 rounded-full w-full py-2 px-5 text-gray-700 leading-tight focus:outline-none focus:shadow"
              name="password"
              type="password"
              component={renderField}
              validate={[required]}
              placeholder="••••••••" />
          </div>
          <div className="flex justify-center">
            <button 
              className={`border border-gray-600 bg-gray-600 text-white font-bold py-2 px-8 rounded-full focus:outline-none focus:shadow ${invalid ? 'opacity-50 cursor-not-allowed' : 'hover:bg-white hover:text-gray-600 cursor-pointer'}`}
              type="submit"
              disabled={invalid}>
              Login
            </button>
          </div>
        </form>
        <p className="text-center text-gray text-xs">
          ©2019 Smart Gaming. Tutti i diritti riservati.
        </p>
      </div>
    </div>
  );
};

const validate = values => {
  const errors = {};

  if (!values.username || isNil(values.username) || isEmpty(values.username)) {
    errors.username = 'Il nome utente è richiesto.';
  }

  if (!values.password || isNil(values.password) || isEmpty(values.password)) {
    errors.password = 'La password è richiesta.';
  }

  return errors;
};

export default reduxForm({
  form: 'login',
  validate,
})(LoginForm);